import { useRef } from 'react';
import { useDraggableItem } from '../hooks/useDraggableItem';
import { EditorItem } from '../store/editorStore';
import { ItemContent } from './item-components/ItemContent';
import { ResizeHandles } from './item-components/ResizeHandles';

type DraggableItemProps = {
  item: EditorItem;
  isSelected: boolean;
  scale: number;
  canvasWidth?: number;
  canvasHeight?: number;
  onSelect: () => void;
};

export function DraggableItem({ item, isSelected, scale, canvasWidth, canvasHeight, onSelect }: DraggableItemProps) {
  const itemRef = useRef<HTMLDivElement>(null);
  
  const {
    itemStyle,
    handleMouseDown,
    handleDoubleClick
  } = useDraggableItem({
    item,
    isSelected,
    scale,
    canvasWidth,
    canvasHeight,
    itemRef,
    onSelect
  });

  return (
    <div
      ref={itemRef}
      style={itemStyle}
      onClick={(e) => {
        e.stopPropagation();
        onSelect();
      }}
      onDoubleClick={handleDoubleClick}
      onMouseDown={handleMouseDown}
      className="editor-item"
      data-selected={isSelected}
    >
      <ItemContent item={item} isEditing={false} />
      {isSelected && <ResizeHandles item={item} />}
    </div>
  );
} 